import { Button, Icon } from '@ds/core';
import { dataSimples, moeda } from '@/comuns/formato';

export interface TesteDaClinica {
    testeAte: string;
    plano: string;
    precoCentavos: number | null;
    cartaoFinal: string | null;
    cancelado: boolean;
}

/**
 * O que a clínica em teste lê no topo (autocadastro, 0150): até quando vai, quanto
 * entra e em qual cartão. Cancelado, que nada será cobrado e quando a clínica fecha.
 * É aviso, não guarda: quem encerra o teste é a rodada diária do banco.
 */
export function textoDoTeste(t: TesteDaClinica): string {
    if (t.cancelado) return `Teste cancelado: nada será cobrado, e a clínica fecha em ${dataSimples(t.testeAte)}.`;
    const valor = t.precoCentavos === null ? '' : ` de ${moeda(t.precoCentavos)}`;
    const cartao = t.cartaoFinal ? ` no cartão final ${t.cartaoFinal}` : '';
    return `Teste do plano ${t.plano} até ${dataSimples(t.testeAte)}. Nesse dia entra a primeira cobrança${valor}${cartao}.`;
}

export function AvisoDeTeste({ teste, onVer }: { teste: TesteDaClinica; onVer?: () => void }) {
    return (
        <div
            role="status"
            style={{
                display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap',
                padding: '9px 18px',
                /* Neutro nos dois temas: teste não é alerta, e o bordô é marca, não estado. */
                background: 'var(--surface-secondary)',
                borderBottom: '1px solid var(--border)', fontFamily: 'var(--font-ui)', fontSize: 13,
                color: 'var(--text-primary)',
            }}
        >
            <Icon name="clock" size={15} style={{ color: 'var(--info)' }} />
            <span style={{ flex: '1 1 220px', minWidth: 0 }}>{textoDoTeste(teste)}</span>
            {onVer && <Button size="sm" variant="secondary" onClick={onVer}>Ver assinatura</Button>}
        </div>
    );
}
